import { getApiUrl } from '../config/demoMode';

const API_URL = getApiUrl();

export const apiRequest = async (endpoint, method = "GET", body = null) => {
  if (!API_URL) {
    throw new Error('API adresi yapılandırılmamış.');
  }

  const response = await fetch(`${API_URL}/${endpoint}`, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body ? JSON.stringify(body) : null
  });

  if (response.status === 401) {
    const path = window.location.pathname;
    if (path !== "/401" && path !== "/login") {
      window.location.href = "/401";
    }
    return null;
  }

  if (response.status === 403) {
    const text = await response.text();
    let data;
    try { data = JSON.parse(text); } catch { data = {}; }
    if (data?.demoExpired) {
      const path = window.location.pathname;
      if (path !== "/demo-suresi-doldu") window.location.href = "/demo-suresi-doldu";
      return null;
    }
    throw new Error(data?.message || "Bu işlem için yetkiniz bulunmamaktadır.");
  }

  if (response.status === 500) {
    const body = await response.text();
    console.error('[500 HATA]', endpoint, body);
    window.location.href = "/500";
    return null;
  }

  const text = await response.text();
  if (!response.ok) {
    let message = 'Sunucu hatası oluştu.';
    try { const json = JSON.parse(text); message = json.message || json.title || json.Message || message; } catch {}
    throw new Error(message);
  }
  return text ? JSON.parse(text) : null;
};

export const getDashboardOzet = (tarih) =>
  apiRequest(`Istatistik/dashboard?tarih=${tarih}`);

export const getGiderKalemleri = (tarih) =>
  apiRequest(`Istatistik/gider-kalemleri?tarih=${tarih}`);

export const getMusaitOdalar = (giris, cikis) =>
  apiRequest(`Istatistik/musait-odalar?giris=${giris}&cikis=${cikis}`);

export const getRezervasyonRaporu = (params) => {
  const q = new URLSearchParams();
  q.set('baslangic',   params.baslangic);
  q.set('bitis',       params.bitis);
  q.set('sayfa',       params.sayfa   ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 50);
  if (params.durum    && params.durum    !== 'Hepsi') q.set('durum',     params.durum);
  if (params.acenteId)                                q.set('acenteId',  params.acenteId);
  if (params.odaTipi  && params.odaTipi  !== 'Hepsi') q.set('odaTipi',   params.odaTipi);
  if (params.personelId)                              q.set('personelId', params.personelId);
  return apiRequest(`Istatistik/rezervasyon-raporu?${q}`);
};

export const getRezervasyonOzet = (baslangic, bitis) =>
  apiRequest(`Istatistik/rezervasyon-ozet?baslangic=${baslangic}&bitis=${bitis}`);

export const getMisafirListesi = (params) => {
  const q = new URLSearchParams();
  q.set('baslangic',  params.baslangic);
  q.set('bitis',      params.bitis);
  q.set('sayfa',      params.sayfa      ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 100);
  if (params.adSoyad       && params.adSoyad !== '')        q.set('adSoyad',       params.adSoyad);
  if (params.ulke          && params.ulke !== '')           q.set('ulke',          params.ulke);
  if (params.cinsiyet      && params.cinsiyet !== 'Farketm') q.set('cinsiyet',     params.cinsiyet);
  if (params.durum         && params.durum !== 'Farketm')   q.set('durum',         params.durum);
  if (params.konaklamaTuru && params.konaklamaTuru !== 'Farketm') q.set('konaklamaTuru', params.konaklamaTuru);
  return apiRequest(`Istatistik/misafir-listesi?${q}`);
};

export const getMisafirUlkeIstatistik = (yil, ay) =>
  apiRequest(`Istatistik/misafir-ulke-istatistik?yil=${yil}&ay=${ay}`);

export const getFiyatAnalizi = (params) => {
  const q = new URLSearchParams();
  q.set('baslangic',   params.baslangic);
  q.set('bitis',       params.bitis);
  q.set('sayfa',       params.sayfa      ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 200);
  if (params.odaNo      && params.odaNo    !== '')      q.set('odaNo',      params.odaNo);
  if (params.adSoyad    && params.adSoyad  !== '')      q.set('adSoyad',    params.adSoyad);
  if (params.paraBirimi && params.paraBirimi !== 'Hepsi') q.set('paraBirimi', params.paraBirimi);
  return apiRequest(`Istatistik/fiyat-analizi?${q}`);
};

export const getGunlukDoluluk = (yil, ay, para) => {
  const q = new URLSearchParams({ yil, ay });
  if (para && para !== 'Hepsi') q.set('para', para);
  return apiRequest(`Istatistik/gunluk-doluluk?${q}`);
};

export const getForecast = (baslangic, bitis) =>
  apiRequest(`Istatistik/forecast?baslangic=${baslangic}&bitis=${bitis}`);

export const getKaraListe = () =>
  apiRequest('Istatistik/kara-liste');

export const addKaraListeKaydi = (dto) =>
  apiRequest('Istatistik/kara-liste', 'POST', dto);

export const deleteKaraListeKaydi = (id) =>
  apiRequest(`Istatistik/kara-liste/${id}`, 'DELETE');

// ── Personel Gider ────────────────────────────────────────────────────────
export const getPersonelGider = (params) => {
  const q = new URLSearchParams();
  q.set('baslangic',   params.baslangic);
  q.set('bitis',       params.bitis);
  q.set('sayfa',       params.sayfa       ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 50);
  if (params.personelHedefId) q.set('personelHedefId', params.personelHedefId);
  return apiRequest(`Istatistik/personel-gider?${q}`);
};

export const addPersonelGider = (dto) =>
  apiRequest('Istatistik/personel-gider', 'POST', dto);

export const updatePersonelGider = (id, dto) =>
  apiRequest(`Istatistik/personel-gider/${id}`, 'PUT', dto);

export const deletePersonelGider = (id) =>
  apiRequest(`Istatistik/personel-gider/${id}`, 'DELETE');

// ── Housekeeping / Oda Durum ──────────────────────────────────────────────
export const getHousekeepingOdalar = () =>
  apiRequest('Istatistik/housekeeping-odalar');

export const updateOdaDurum = (odaId, durum) =>
  apiRequest(`Istatistik/housekeeping-odalar/${odaId}`, 'PATCH', { durum });

// ── Laundry ───────────────────────────────────────────────────────────────
export const getLaundryKayitlar = (params = {}) => {
  const q = new URLSearchParams();
  q.set('sayfa',       params.sayfa       ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 100);
  if (params.tarih)      q.set('tarih',      params.tarih);
  if (params.durum && params.durum !== 'Hepsi') q.set('durum', params.durum);
  if (params.personelId) q.set('personelId', params.personelId);
  return apiRequest(`Istatistik/laundry-kayitlar?${q}`);
};

export const addLaundryKayit = (dto) =>
  apiRequest('Istatistik/laundry-kayitlar', 'POST', dto);

export const updateLaundryKayit = (id, dto) =>
  apiRequest(`Istatistik/laundry-kayitlar/${id}`, 'PUT', dto);

export const deleteLaundryKayit = (id) =>
  apiRequest(`Istatistik/laundry-kayitlar/${id}`, 'DELETE');

// ── Misafir Mesajları ─────────────────────────────────────────────────────
export const getMisafirMesajlar = (okunmamis = false) =>
  apiRequest(`misafir-mesaj${okunmamis ? '?okunmamis=true' : ''}`);
export const mesajOkundu = (id) =>
  apiRequest(`misafir-mesaj/${id}/okundu`, 'PUT');
export const deleteMisafirMesaj = (id) =>
  apiRequest(`misafir-mesaj/${id}`, 'DELETE');

// ── E-posta Log ───────────────────────────────────────────────────────────
export const getEpostaLoglar = (params = {}) => {
  const q = new URLSearchParams();
  q.set('baslangic',   params.baslangic);
  q.set('bitis',       params.bitis);
  q.set('sayfa',       params.sayfa       ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 100);
  if (params.durum && params.durum !== 'Hepsi') q.set('durum', params.durum);
  return apiRequest(`Istatistik/eposta-loglar?${q}`);
};

// ── Sistem Log ────────────────────────────────────────────────────────────
export const getSistemLoglar = (params = {}) => {
  const q = new URLSearchParams();
  q.set('baslangic',   params.baslangic);
  q.set('bitis',       params.bitis);
  q.set('sayfa',       params.sayfa       ?? 1);
  q.set('sayfaBoyutu', params.sayfaBoyutu ?? 200);
  if (params.islem) q.set('islem', params.islem);
  return apiRequest(`Istatistik/sistem-loglar?${q}`);
};

export const login = async (kullaniciAdi, sifre) => {
  if (!API_URL) {
    throw new Error('API adresi yapılandırılmamış.');
  }

  const response = await fetch(`${API_URL}/Auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ kullaniciAdi, sifre })
  });
  return response.json();
};
